var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasklistDocumentText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66666 3.33366L7.75 1.97949C7.90833 1.78199 8.1475 1.66699 8.40083 1.66699H11.6C11.8533 1.66699 12.0925 1.78199 12.2508 1.97949L13.3333 3.33366V3.33366V4.16699C13.3333 4.62699 12.96 5.00033 12.5 5.00033H7.5C7.04 5.00033 6.66666 4.62699 6.66666 4.16699V3.33366V3.33366H6.66666Z",
    stroke: "#4D5E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 3.33398H5C4.07917 3.33398 3.33333 4.07982 3.33333 5.00065V15.834C3.33333 16.7548 4.07917 17.5007 5 17.5007H15C15.9208 17.5007 16.6667 16.7548 16.6667 15.834V5.00065C16.6667 4.07982 15.9208 3.33398 15 3.33398H13.3333",
    stroke: "#4D5E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66666 9.16667H13.3333",
    stroke: "#4D5E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66666 13.3337H13.3333",
    stroke: "#4D5E93",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasklistDocumentText);
export default __webpack_public_path__ + "static/media/Task list, Document, Text.9aae2ea2c9f07f865049be06601aaf4e.svg";
export { ForwardRef as ReactComponent };